declare var swal: any;
import { Component, OnInit, Input } from '@angular/core';
//import * as Chartist from 'chartist';
//import { ChartType, ChartEvent } from "ng-chartist/dist/chartist.component";
import { AppData } from '../../../../../../src/app/ncs/models/appdata';
import { IsSessionExistsRequest } from '../../../../../../src/app/ncs/models/login/loginrequestmodel';
import { Router, ActivatedRoute } from '@angular/router';
import { LoginService } from '../../../../../../src/app/ncs/services/login.service';
import { ApiResponseModel } from '../../../../../../src/app/ncs/models/api_response_model';
//import { Observable } from 'rxjs/Observable';
//import { Subscription } from 'rxjs/Subscription';
import { ActorDashBoardProfileSummaryInfoRequest, DashBoardProfileSummaryController } from '../../../../../../src/app/ncs/models/profileinfo/profileinfo.model';
import { HCPService } from '../../../../../../src/app/ncs/services/hcp.service';
import { SpinnerService } from '../../../../../../src/app/ncs/services/spinner.service';
//import { NgbScheduleAssistantModal } from './scheduleassistant/scheduleassistant.modal';

declare var require: any;


import * as alertFunctions from '../../../../../../src/app/shared/data/sweet-alerts';
import { Observable, Subscription } from 'rxjs';
import { routerTransition } from '../../../animations/router.animations';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { PatientInfoByFormattedCodeRequest, PatientInfoByFormattedCodeController, IahOrdersController, IahOrderItemsController, IahOrderItemsRequest, IahOrderStatusTrackController, IahOrderStatusTrackRequest, IahOrdersRequest, SaveIahOrderItemStatusRequest, GenerateIahBillRequest } from '../../../../../../src/app/ncs/models/actor/actor';
import { ActorService } from '../../../../../../src/app/ncs/services/actor.service';
//import { NgbAddNewPatient } from './modal/addnewpatient.modal';
import { NgbCameraUploadModal } from '../profile/patientprofileview/personaldetailview/modal/cameraupload.modal';
import { NgbEditItemsModal } from './modal/edititems.modal';
import { PrintService } from '../../../../../../src/app/ncs/services/print.service';
import { ItemsIahpipe } from '../../../pipes/actors/actorIdentity.pipes';
import { NGXToastrService } from '../../../../shared/services/toastr.service';
//import { IahItemsPipe } from '../../../pipes/actors/actorIdentity.pipes';





@Component({
  selector: 'iohvieworder',
  templateUrl: './iohvieworder.component.html',
  styleUrls: [
    './iohvieworder.component.scss']
  , animations: [routerTransition()]
})

export class IOHViewOrderComponent implements OnInit {

  OnGoBack() {
    //alert("I cam bak");
    this.ShowList = true;
  }
  GetActorIdentitiesController(): any {
    throw new Error("Method not implemented.");
  }
    //@Input() Code: number;
    @Input() SelectedData: IahOrdersController[];
  public ActorCode: number = 0;
  public FormattedCode: number = 0;
  public isNew: boolean = false;
  public isEdit: boolean = false;
  public IsExpand: boolean = true;
  public Showarrow: boolean = false;
  public ShowRegister: boolean = true;
  public Showrow: boolean = true;
  public ShowPatientDetails: boolean = false;
  public isRequesting: boolean = false;
  public searchValue: string;
    public searchText: any;
    public OrderCode: any;
    public CustomerName: any;
    public Address: any;
    public OrderDate: any;
    public OrderType: any;
    public Age: any;
    public Mobilenumber: any;
    public Status: any;
    public CActorCode: number;
    public SelectedData2: any;
    public Total: number;
    public CUser: any;
  searchTitle: string;
    CurrentIsSessionExistsRequest: IsSessionExistsRequest;
    CurrentSaveIahOrderItemStatusRequest: SaveIahOrderItemStatusRequest;
    CurrentGenerateIahBillRequest: GenerateIahBillRequest;
  public ApiResData: ApiResponseModel;
   // CurrentIahOrdersController: IahOrdersController[];
  CurrentActorDashBoardProfileSummaryInfoRequest: ActorDashBoardProfileSummaryInfoRequest;
  CurrentDashBoardProfileSummaryController: DashBoardProfileSummaryController;
  CurrentPatientInfoByFormattedCodeController: PatientInfoByFormattedCodeController[];
  CurrentPatientInfoByFormattedCodeRequest: PatientInfoByFormattedCodeRequest;
  LoadPatients() {
    this.CurrentPatientInfoByFormattedCodeRequest = new PatientInfoByFormattedCodeRequest();
    this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = "GG1O/577";
    this.CurrentPatientInfoByFormattedCodeRequest.Branch = AppData.Instance().SelectedBranchCode;
    this.CurrentPatientInfoByFormattedCodeRequest.ConditionalOperator = 20;
    this.CurrentPatientInfoByFormattedCodeRequest.FromDate = new Date();
    this.CurrentPatientInfoByFormattedCodeRequest.ToDate = new Date();
    this.CurrentPatientInfoByFormattedCodeRequest.IsToday = true;
    this.CurrentPatientInfoByFormattedCodeRequest.IsDuration = false;
    this.CurrentPatientInfoByFormattedCodeRequest.SearchText = "";
    this.CurrentPatientInfoByFormattedCodeRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.GetPatientInfoByFormattedCodeController();
  }
  RefreshPatients(st: string) {
    this.CurrentPatientInfoByFormattedCodeRequest = new PatientInfoByFormattedCodeRequest();
    this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = "";
    this.CurrentPatientInfoByFormattedCodeRequest.Branch = 0;
    this.CurrentPatientInfoByFormattedCodeRequest.ConditionalOperator = 20;
    this.CurrentPatientInfoByFormattedCodeRequest.FromDate = new Date();
    this.CurrentPatientInfoByFormattedCodeRequest.ToDate = new Date();
    this.CurrentPatientInfoByFormattedCodeRequest.IsToday = true;
    this.CurrentPatientInfoByFormattedCodeRequest.IsDuration = false;
    this.CurrentPatientInfoByFormattedCodeRequest.SearchText = st;

    this.CurrentPatientInfoByFormattedCodeRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this._GetPatientInfoByFormattedCodeController();
  }
  _GetPatientInfoByFormattedCodeController() {
    this.StartRefreshing();


    this.actorservice.GetPatientInfoByFormattedCodeController(this.CurrentPatientInfoByFormattedCodeRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {

          this.CurrentPatientInfoByFormattedCodeController = null;
          this.CurrentPatientInfoByFormattedCodeController = this.ApiResData.Result;
          //  this.SelectedService = this.CurrentServiceDetailsByCodeController[0];
          //alert(this.CurrentServiceDetailsByCodeController[0].CategoryName);
          //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.ActorCode.toString();
          this.stopRefreshing();

        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();
          }
        }


      );
  }
  GetPatientInfoByFormattedCodeController() {
    this.StartRefreshing();


    this.actorservice.GetPatientInfoByFormattedCodeController(this.CurrentPatientInfoByFormattedCodeRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {

          this.CurrentPatientInfoByFormattedCodeController = this.ApiResData.Result;
          //  this.SelectedService = this.CurrentServiceDetailsByCodeController[0];
          //alert(this.CurrentServiceDetailsByCodeController[0].CategoryName);
          //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.ActorCode.toString();
          this.stopRefreshing();

        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();
          }
        }


      );
    }
    CurrentIahOrdersController: IahOrdersController[];
    SelectedOrderData: IahOrdersController;
    CurrentIahOrdersRequest: IahOrdersRequest;
    LoadOrders() {
        this.CurrentIahOrdersRequest = new IahOrdersRequest();

        // this.CurrentIahOrdersRequest.BranchCode = AppData.Instance().SelectedBranchCode;


        this.CurrentIahOrdersRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
        //this.pdata = this.CurrentIahOrdersController;
        this.GetIahOrdersController();
    }

    GetIahOrdersController() {
        this.StartRefreshing();
        this.CurrentIahOrdersRequest.ConditionalOperator = 30;
        this.CurrentIahOrdersRequest.BranchCode = this.OrderCode;
        this.CurrentIahOrdersRequest.FromDate = new Date();
        this.CurrentIahOrdersRequest.ToDate = new Date();

        this.actorservice.GetIahOrdersController(this.CurrentIahOrdersRequest)
            .subscribe((result) => {
                this.ApiResData = result;
                if (!this.ApiResData.hasError) {

                    this.CurrentIahOrdersController = this.ApiResData.Result;
                    this.SelectedOrderData = this.CurrentIahOrdersController[0];
                   // this.pdata = this.CurrentIahOrdersController;
                    this.stopRefreshing();

                }
                else {
                    this.stopRefreshing();
                    if (this.ApiResData.ErrorData != "") {

                        alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
                    }
                    else {
                        alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
                    }
                }

            },


                (error) => {

                    if (error == "401 - Unauthorized") {
                        alertFunctions.AlertParamEr(error);
                        this.stopRefreshing();



                    }
                    else {
                        alertFunctions.AlertParamEr(error);
                        this.stopRefreshing();
                    }
                }


            );
    }

    CurrentIahOrderItemsController: IahOrderItemsController[];
    CurrentIahOrderItemsRequest: IahOrderItemsRequest;
    LoadPatients2() {
        this.CurrentIahOrderItemsRequest = new IahOrderItemsRequest();

        // this.CurrentIahOrdersRequest.BranchCode = AppData.Instance().SelectedBranchCode;


        this.CurrentIahOrderItemsRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
        this.pdata = this.CurrentIahOrderItemsController;

        this.GetIahOrderItemsController();
    }

    GetIahOrderItemsController() {
        this.StartRefreshing();
        this.CurrentIahOrderItemsRequest.ConditionalOperator = 10;
        this.CurrentIahOrderItemsRequest.IahOrderCode = this.OrderCode;
        //this.CurrentIahOrderItemsRequest.ActorCode = this.CActorCode;
      

        this.actorservice.GetIahOrderItemsController(this.CurrentIahOrderItemsRequest)
            .subscribe((result) => {
                this.ApiResData = result;
                if (!this.ApiResData.hasError) {

                    this.CurrentIahOrderItemsController = this.ApiResData.Result;
                   this.pdata = this.CurrentIahOrderItemsController;
                    this.stopRefreshing();

                }
                else {
                    this.stopRefreshing();
                    if (this.ApiResData.ErrorData != "") {

                        alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
                    }
                    else {
                        alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
                    }
                }

            },


                (error) => {

                    if (error == "401 - Unauthorized") {
                        alertFunctions.AlertParamEr(error);
                        this.stopRefreshing();



                    }
                    else {
                        alertFunctions.AlertParamEr(error);
                        this.stopRefreshing();
                    }
                }


            );
    }

    CurrentIahOrderStatusTrackController: IahOrderStatusTrackController[];
    CurrentIahOrderStatusTrackRequest: IahOrderStatusTrackRequest;
    LoadTrack() {
        this.CurrentIahOrderStatusTrackRequest = new IahOrderStatusTrackRequest();

        // this.CurrentIahOrdersRequest.BranchCode = AppData.Instance().SelectedBranchCode;


        this.CurrentIahOrderStatusTrackRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
        this.GetIahOrderStatusTrackController();
    }

    GetIahOrderStatusTrackController() {
        this.StartRefreshing();
        this.CurrentIahOrderStatusTrackRequest.ConditionalOperator = 10;
        this.CurrentIahOrderStatusTrackRequest.IahOrderCode = this.OrderCode;
        //this.CurrentIahOrderItemsRequest.ActorCode = this.CActorCode;


        this.actorservice.GetIahOrderStatusTrackController(this.CurrentIahOrderStatusTrackRequest)
            .subscribe((result) => {
                this.ApiResData = result;
                if (!this.ApiResData.hasError) {

                    this.CurrentIahOrderStatusTrackController = this.ApiResData.Result;

                    this.stopRefreshing();

                }
                else {
                    this.stopRefreshing();
                    if (this.ApiResData.ErrorData != "") {

                        alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
                    }
                    else {
                        alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
                    }
                }

            },


                (error) => {

                    if (error == "401 - Unauthorized") {
                        alertFunctions.AlertParamEr(error);
                        this.stopRefreshing();



                    }
                    else {
                        alertFunctions.AlertParamEr(error);
                        this.stopRefreshing();
                    }
                }


            );
    }


  sub: Subscription;
  constructor(private router: Router,
    private loaderService: SpinnerService,
    public printService: PrintService,
    private hcpservice: HCPService,
      private actorservice: ActorService,
      private filter: ItemsIahpipe,
      private tosterservice: NGXToastrService,
    private modalService: NgbModal,
    private route: ActivatedRoute,
      private loginservice: LoginService) {
          //this.route.queryParams.subscribe(params => {
          //    this.CustomerName = params["Name"];
          //    this.OrderCode = params["Code"];
          //    this.Mobilenumber = params["Phone"];
          //    this.Address = params["Address"];
          //    this.Age = params["Age"];
          //    this.OrderDate = params["Date"];
          //    this.CActorCode = params["ActorCode"];
          //    this.Status = params["Status"];
          //    this.Total = params["Total"];
          //    this.CUser = params["CreatedUser"];

          //});
  }

  ngOnInit() {
      this.OrderCode = this.route.snapshot.paramMap.get('Code');
      this.OrderType = this.route.snapshot.paramMap.get('OrderType');
     // this.CustomerName = this.route.snapshot.paramMap.get('CustomerName');
     // this.Address = this.route.snapshot.paramMap.get('Address');
      //this.OrderDate = this.route.snapshot.paramMap.get('OrderDate');
      //this.Age = this.route.snapshot.paramMap.get('Age');
      //this.Mobilenumber = this.route.snapshot.paramMap.get('Mobilenumber');
      //this.Status = this.route.snapshot.paramMap.get('Status');
      ////this.route.queryParams.subscribe(params => {
      ////    this.CustomerName = params["Name"];
      ////    this.OrderCode = params["Code"];
        
      ////});
      //alert(this.CurrentIahOrdersController[0].Code);
      this.LoadOrders();
      this.LoadPatients2();
      this.LoadTrack();
      this.CurrentSaveIahOrderItemStatusRequest = new SaveIahOrderItemStatusRequest();
      this.CurrentSaveIahOrderItemStatusRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
      this.CurrentGenerateIahBillRequest = new GenerateIahBillRequest();
      this.CurrentGenerateIahBillRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;

    this.CurrentActorDashBoardProfileSummaryInfoRequest = new ActorDashBoardProfileSummaryInfoRequest();
    this.CurrentDashBoardProfileSummaryController = new DashBoardProfileSummaryController();


    this.ActorCode = AppData.Instance().UserLoginDetails.ActorCode;
    this.isNew = true;
    this.CurrentActorDashBoardProfileSummaryInfoRequest.ActorCode = this.ActorCode;
    this.CurrentActorDashBoardProfileSummaryInfoRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.GetDashBoardProfileSummaryController();
    //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.SelectedPatient.FormattedCode;
    this.LoadPatients();
    //this.GetPatientInfoByFormattedCodeController();

  }



  ShowList: boolean = true;

  GetDashBoardProfileSummaryController() {
    //  console.log(this.CurrentActorProfileRequest.SendApiRequestModel.xAuthGenKEY);
    this.StartRefreshing();
    this.hcpservice.GetDashBoardProfileSummaryController(this.CurrentActorDashBoardProfileSummaryInfoRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {
          //  console.log('GetActorProfileController');
          this.CurrentDashBoardProfileSummaryController = this.ApiResData.Result[0];
          this.stopRefreshing();

        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();
          }
        }


      );

  }

  BackToProfile() {
    this.ShowList = true;
    this.ShowPatientDetails = false;
    this.Showarrow = false;
  }


  clearData() {
    this.isNew = true;
    this.ShowList = false;

  }
  ExpandData() {
    if (this.IsExpand === true) {
      this.IsExpand = false;
    }
    else {
      this.IsExpand = true;
    }
  }

  //AddNewPatient() {

  //  const modalRef = this.modalService.open(NgbAddNewPatient,
  //    {
  //      centered: true,
  //      size: "lg",
  //      backdrop: 'static',
  //      keyboard: false
  //    })
  //  modalRef.componentInstance.ActorCode = this.ActorCode;

  //  modalRef.result.then(x => { this.GetPatientInfoByFormattedCodeController() })

  //}
  CancelNewOperation() {

    this.ShowList = true;
  }

  ///////////
  private stopRefreshing() {
    this.loaderService.displayLoader(false);
    this.isRequesting = false;
  }
  private StartRefreshing() {
    this.loaderService.displayLoader(true);
    this.isRequesting = true;
  }


  gotoprofile() {
    this.router.navigate(['testnurse/profile']);

  }

  SelectedPatient: PatientInfoByFormattedCodeController;
  ViewPatientDetails(objCategory: any) {
    var patient: PatientInfoByFormattedCodeController = objCategory;

    if (patient != null) {



      this.ShowPatientDetails = true;
      this.ShowList = false;
      this.SelectedPatient = patient;
      this.Showarrow = true;
      this.Showrow = false;
      this.ShowRegister = false;
      //this.LoadPatientdetails()

    }
    else {
      this.ShowPatientDetails = false;
    }
  }
  //SelectedPatientDetailsController: PatientInfoByFormattedCodeController;
  //SelectedPatientDetailsRequest: PatientInfoByFormattedCodeRequest;
  //LoadPatientdetails() {


  //  this.SelectedPatientDetailsRequest = new PatientInfoByFormattedCodeRequest();

  //  this.SelectedPatientDetailsRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
  //  this.SelectedPatientDetailsRequest.FormattedCode = this.SelectedPatient.ActorCode.toString();// AppData.Instance().UserLoginDetails.FacilityActorCode;
  //  this.GetPatientInfoByFormattedCodeController();
  //}

    pdata: any[];// = this.data;
    listFilter: string;
    ngOnChanges(changes: any) {
        if (JSON.stringify(changes).indexOf("data") != -1)
            this.pdata = this.CurrentIahOrderItemsController;

        this.criteriaChange(this.listFilter);
    }
    criteriaChange(value: any) {
        if (this.filter != null) {
            if (value != '[object Event]') {
                this.listFilter = value;
                //alert(this.listFilter);
                this.pdata = this.filter.transform(this.CurrentIahOrderItemsController,
                    this.listFilter);
            }
        }
    }

  capture(l: PatientInfoByFormattedCodeController) {
    const modalRef = this.modalService.open(NgbCameraUploadModal,
      {
        centered: true,


      })
    modalRef.componentInstance.ActorCode = l.ActorCode;
    modalRef.componentInstance.Photo = l.Photo;
  }
  ClearInput() {
    this.searchValue = '';
    // this.searchValue = null;
    //var searchtext = '';
    this.RefreshPatients(this.searchValue);
  }
  BackToOrders() {
      
      if (this.OrderType == "Home") {
          this.router.navigate(['/healins/iohorders']);
      }
      else {
          this.router.navigate(['healins/profileview', { FormattedCode: this.SelectedOrderData.CustomerActorFormattedCode, DisplayName: this.SelectedOrderData.CustomerName, title: "cycle" }]);
      }

  }
    EditItem(l: IahOrderItemsController) {
        this.CurrentSaveIahOrderItemStatusRequest.AssignedTo = l.AssignedTo;
        this.CurrentSaveIahOrderItemStatusRequest.AssignedToName = l.AssignedToName;
       // this.CurrentSaveIahOrderItemStatusRequest.Timestamp = l.ScheduledDate;
        this.CurrentSaveIahOrderItemStatusRequest.Time = l.ScheduledTime;
        this.CurrentSaveIahOrderItemStatusRequest.OrderItemStatus = l.ServiceStatus;
        this.CurrentSaveIahOrderItemStatusRequest.Comments = l.Comments;
    const modalRef = this.modalService.open(NgbEditItemsModal,
      {
          centered: true,
          size: 'lg'

      })
        modalRef.componentInstance.ModelType = "Track Items";
        modalRef.componentInstance.CustomerName = this.SelectedOrderData.CustomerName;
        modalRef.componentInstance.OrderCode = this.SelectedOrderData.Code;
        modalRef.componentInstance.Address = this.SelectedOrderData.DeliverToAddress;
        modalRef.componentInstance.OrderDate = this.SelectedOrderData.OrderDate;
        modalRef.componentInstance.Date = l.ScheduledDate;
        modalRef.componentInstance.ServiceName = l.ItemName;
        modalRef.componentInstance.ItemCode = l.ItemCode;
        modalRef.componentInstance.CurrentSaveIahOrderItemStatusRequest = this.CurrentSaveIahOrderItemStatusRequest;
        modalRef.result.then(x => { this.GetIahOrderItemsController() })
  }

    ViewItem(l: IahOrderItemsController) {
    const modalRef = this.modalService.open(NgbEditItemsModal,
      {
          centered: true,
          size: 'lg'

      })
        modalRef.componentInstance.ModelType = "View Items";
        modalRef.componentInstance.CustomerName = this.SelectedOrderData.CustomerName;
        modalRef.componentInstance.OrderCode = this.SelectedOrderData.Code;
        modalRef.componentInstance.Address = this.SelectedOrderData.DeliverToAddress;
        modalRef.componentInstance.OrderDate = this.SelectedOrderData.OrderDate;
        modalRef.componentInstance.ServiceName = l.ItemName;
        modalRef.componentInstance.ItemCode = l.ItemCode;
        modalRef.componentInstance.ScheduleDate = l.ScheduledDate;
        modalRef.componentInstance.ScheduleTime = l.ScheduledTime;
        modalRef.componentInstance.OrderStatus = l.ServiceStatus;
        modalRef.componentInstance.Comments = l.Comments;
        modalRef.componentInstance.AssignedNmae = l.AssignedToName;
       
    //modalRef.result.then(x => { this.GetEmergencyContactInfoController() })
  }
  EditItem2() {
    const modalRef = this.modalService.open(NgbEditItemsModal,
      {
          centered: true,
          size: 'lg'

      })
      modalRef.componentInstance.ModelType = "Update Status2";
      modalRef.componentInstance.CustomerName = this.SelectedOrderData.CustomerName;
      modalRef.componentInstance.OrderCode = this.SelectedOrderData.Code;
      modalRef.componentInstance.Address = this.SelectedOrderData.DeliverToAddress;
      modalRef.componentInstance.OrderDate = this.SelectedOrderData.OrderDate;
      modalRef.componentInstance.CreUser = this.SelectedOrderData.CreatedUser;
      modalRef.componentInstance.Status = this.SelectedOrderData.OrderStatus;
      modalRef.result.then(x => { this.GetIahOrdersController() })

  }
    ViewOrder() {
        this.CurrentGenerateIahBillRequest.ConditionalOperator = 10;
        this.CurrentGenerateIahBillRequest.IahOrderCode = this.OrderCode;
        this.actorservice.GenerateIahBill(this.CurrentGenerateIahBillRequest)
          .subscribe((result) => {
              this.ApiResData = result;
              if (!this.ApiResData.hasError) {

                  if (this.ApiResData.Result > 0) {
                      //this.GetActorEducationInfoController();
                      //this.GetResourceIdentificationByDateInfoController();
                      // alertFunctions.AlertParam('Saved Successfully.....!');
                      this.tosterservice.ToasterSuccessAlertParam('Saved Successfully.....!');

                      // this.Listview = true;
                      //this.EditEmbryo = false;
                      //this.LoadStoreData();
                      //this.AddEmbryo = false;
                      //this.spinner.hide();
                      //this.activeModal.close();
                      //this.clearData();
                      // this.LoadScansData();
                      this.stopRefreshing();
                      this.router.navigate(['healins/ConsumptionEntry']);
                  }
                  else {
                      alertFunctions.AlertParam("Invalid Operation...!");

                      //this.spinner.hide();
                      this.stopRefreshing();

                  }

              }
              else {
                  this.stopRefreshing();
                  if (this.ApiResData.ErrorData != "") {

                      //alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
                      alert(this.ApiResData.ErrorData);


                  }
                  else {
                      //this.spinner.hide();
                      this.stopRefreshing();
                      alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');

                  }
              }

          },


              (error) => {

                  if (error == "401 - Unauthorized") {
                      alertFunctions.AlertParamEr(error);
                      // this.spinner.hide();
                      this.stopRefreshing();



                  }
                  else {
                      alertFunctions.AlertParamEr(error);
                      // this.spinner.hide();
                      this.stopRefreshing();
                  }
              }
          );
  }
  printservices() {
    this.printService.printDocument("iohvieworderPV",
      {
        IahOrderCodeData: this.OrderCode, OrderDate: this.SelectedOrderData.OrderDate, OrderNo: this.SelectedOrderData.Code, FormattedCode: this.SelectedOrderData.CustomerActorFormattedCode, TotalAmount: this.SelectedOrderData.TotalAmount, Gender: this.SelectedOrderData.Gender, CustomerName: this.SelectedOrderData.CustomerName, AgeY: this.SelectedOrderData.AgeY, MobileNumber: this.SelectedOrderData.MobileNumber, DeliverToAddress: this.SelectedOrderData.DeliverToAddress, 

      }
    );
  }
  printservicesindi(l: IahOrderItemsController) {
    this.printService.printDocument("iohvieworderPVindi",
      {
        IahOrderCodeData: this.OrderCode, OrderDate: this.SelectedOrderData.OrderDate, OrderNo: this.SelectedOrderData.Code, FormattedCode: this.SelectedOrderData.CustomerActorFormattedCode, TotalAmount: this.SelectedOrderData.TotalAmount, Gender: this.SelectedOrderData.Gender, CustomerName: this.SelectedOrderData.CustomerName, AgeY: this.SelectedOrderData.AgeY, MobileNumber: this.SelectedOrderData.MobileNumber, DeliverToAddress: this.SelectedOrderData.DeliverToAddress,
        OrderStatus: l.ServiceStatus, ItemName: l.ItemName, CreatedUser: this.SelectedOrderData.CreatedUser, PrescName: this.SelectedOrderData.PrescName,
      }
    );
    }
    OrderRefresh() {
        this.LoadTrack();
    }
    OrderRefresh2() {
        this.LoadPatients2();
    }
}
